import { resolve } from 'aurelia';
import {
    IRouteViewModel,
    NavigationInstruction,
    Params,
    RouteNode,
} from '@aurelia/router-lite';
import { lifecycleHooks } from '@aurelia/runtime-html';
import { IStore } from '@aurelia/state';
import { ActionNames, UpdateMetaDescription } from '../../state';

@lifecycleHooks()
export class MetadataHook {
    private readonly store: IStore<{}, UpdateMetaDescription> = resolve(IStore);

    public loading(
        _viewmodel: IRouteViewModel,
        _params: Params,
        next: RouteNode
    ): boolean | NavigationInstruction {
        this.store.dispatch({ type: ActionNames.UPDATE_META_DESCRIPTION, value: next.data?.metaDescription! as string });
        return true;
    }
}
